__turbopack_context__.v({
  "container": "Select-module__xItvXq__container",
  "container__arrow": "Select-module__xItvXq__container__arrow",
  "container__input": "Select-module__xItvXq__container__input",
  "container__input__small": "Select-module__xItvXq__container__input__small",
});
